<app-navbar></app-navbar>
<section>
    <div class="error_section container">
        <img src="../../assets/images/404/404.png" alt="error 404">
        <h2 >Whoops<span>!</span> Lost in space<span>?</span></h2>
        <h3>
            The page you are looking for isn't found :(<br>
            We suggest you go back home.
        </h3>
    </div>
</section>